/**
 * Null UI Provider - no-op implementation for testing
 */
import { EventEmitter } from 'eventemitter3';
export class NullUIProvider extends EventEmitter {
    // === Screen ===
    setScreen(_handle, _cyclic) { }
    blankScreen() { }
    clearRect(_row, _col, _width, _height) { }
    setTitle(_title) { }
    setColor(_foreground, _background) { }
    setLineBaseRow(_baseRow) { }
    getCurrentColors() {
        return { fg: 1, bg: 0 };
    }
    // === Pagination (no-op; `getVisibleLineCount() = 0` tells the
    //     screen executor "no fixed viewport, run every LINE block") ===
    setTotalLines(_total) { }
    setVisibleLineCount(_count) { }
    getFirstVisibleLine() {
        return 0;
    }
    getVisibleLineCount() {
        return 0;
    }
    scrollLines(_delta) { }
    scrollToTop() { }
    scrollToBottom() { }
    async scriptSelect(_iniFile) {
        return null;
    }
    async ensureConnected() {
        // Null provider can't drive a UI flow — assume connection is
        // managed externally and resolve immediately.
    }
    async confirmConnectError(_message) {
        // No interactive surface — default to "continue" so the script
        // doesn't hang waiting for a button click that can't happen.
        return "continue";
    }
    // === Menu ===
    setMenuTitle(_title) { }
    setMenu(_handle) { }
    setItem(_itemNum, _text, _enabled) { }
    setItemRepeat(_itemNum, _enabled) { }
    // === Text Output ===
    text(_row, _col, _text) { }
    textOut(_text, _row, _col) { }
    fTextOut(_text, _row, _col, _fgColor, _bgColor, _fontSize, _fontAttr) { }
    fTextClear(_text, _row, _col, _textSize, _textAttr) { }
    hexDump(_row, _col, _data, _len) { }
    // === Data Output ===
    digitalOut(_value, _row, _col, _trueText, _falseText) { }
    analogOut(_value, _row, _col, _min, _max, _minValid, _maxValid, _format) { }
    multiAnalogOut(_value, _row, _col, _min, _max, _minValid, _maxValid, _format, _mode) { }
    // === Input (return defaults) ===
    getInputState() {
        return 0;
    }
    async inputText(_title, _text) {
        return '';
    }
    async input2Text(_title, _text, _str1Label, _str2Label) {
        return ['', ''];
    }
    async inputNum(_title, _text, min, _max) {
        return min;
    }
    async inputInt(_title, _text, min, _max) {
        return min;
    }
    async input2Int(_title, _text, _label1, _label2, min1, _max1, min2, _max2) {
        return [min1, min2];
    }
    async inputHex(_title, _text, min, _max) {
        return min;
    }
    async input2Hex(_title, _text, _label1, _label2, min1, _max1, min2, _max2) {
        return [min1, min2];
    }
    async input2HexNum(_title, _text, _hexLabel, _numLabel, minHex, _maxHex, minNum, _maxNum) {
        return [minHex, minNum];
    }
    async inputDigital(_title, _text, _offText, _onText) {
        return false;
    }
    async togglelist(_multipleSelect, _argNum, _items) {
        return '';
    }
    // === Message Boxes ===
    async messageBox(_title, _text) { }
    async infoBox(_title, _text) { }
    userBoxOpen(_boxNum, _row, _col, _height, _width, _title, _text) { }
    userBoxClose(_boxNum) { }
    userBoxFTextOut(_boxNum, _text, _row, _col, _foreColor, _backColor) { }
    userBoxClear(_boxNum) { }
    userBoxSetColor(_boxNum, _foreColor, _backColor) { }
}
//# sourceMappingURL=ui.js.map